<template>
  <div class="mb-3 row">
    <label :for="item.id" class="col-sm-2 col-form-label">{{ item.name }}</label>
    <div class="col-sm-2">
      <input :id="item.id" :name="item.id" :type="item.type" :maxlength="item.length || getMaxlength(item.stype)" :value="item.value" :disabled="!item.isVisible" class="form-control" @input="updateValue"   :class="{ 'is-invalid': error }"/>
      <div v-if="error" class="invalid-feedback">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent ({
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    emits: ['updateValue', 'error'],
    setup(props, { emit }) {
      const error = ref(false);
      const errorMessage = ref('');

      const updateValue = (event) => {
        const newValue = event.target.value;
        if (!validateValue(newValue, props.item)) {
            error.value = true;
            errorMessage.value = getErrorMessage(props.item);
            //emit('error', { item: props.item, errorMessage: errorMessage.value });
        } else {
            error.value = false;
            errorMessage.value = '';
        }
        emit('updateValue', { id: props.item.id, value: newValue, error: error.value, errorMessage: errorMessage.value });
      }

      const validateValue = (value, item) => {
        if (item.stype === 'number') {
            return validateNumber(value, item.digits, item.range);
        } else if (item.stype === 'hex') {
            return validateHex(value, item.length);
        } else if (item.stype === 'fqdn') {
            return validateFQDN(value, item.length);
        } else if (item.stype === 'ipv4') {
            return validateIPv4(value, item.length);
        } else if (item.stype === 'ipv4mask') {
            return validateIPv4Mask(value, item.length);
        } else if (item.stype === 'ipv6') {
            return validateIPv6(value, item.length);
        } else if (item.stype === 'ipv6prefix') {
            return validateIPv6Prefix(value, item.length);
        } else if (item.stype === 'email') {
            return validateEmail(value, item.length);
        } else {
            return validateString(value, item.regexp);
        }
      }

      const validateNumber = (value, digits, range) => {
          const num = Number(value);
          let ret = true;
          if(isNaN(num))
            return false;
          if(range != undefined) {
            const parts = range.split('-');
            const start = Number(parts[0]);
            const end = Number(parts[1]);
            ret = num >= start && num <= end ? true : false;
          }
          if(ret && digits != undefined) {
            const parts = props.item.digits.split('.');
            ret = num.toString().length <= parseInt(parts[0], 10) ? true : false;
          }
          //return !isNaN(num) && num.toString().length === digits && num >= range.start && num <= range.end;
          return ret;
      }

      const validateHex = (value, length) => {
          return /^[0-9A-Fa-f]*$/.test(value) && value.length <= length;
      }

      const validateFQDN = (value, length) => {
          return /^[a-zA-Z0-9.-]{1,40}$/.test(value) && value.length <= length;
      }

      const validateIPv4 = (value, length) => {
          return /^[0-9]{1,3}(\.[0-9]{1,3}){3}$/.test(value) && value.length <= length;
      }

      const validateIPv4Mask = (value, length) => {
          return /^[0-9]{1,3}(\.[0-9]{1,3}){3}$/.test(value) && value.length <= length;
      }

      const validateIPv6 = (value, length) => {
          return /^[a-fA-F0-9:]*$/.test(value) && value.length <= length;
      }

      const validateIPv6Prefix = (value, length) => {
          return /^[a-fA-F0-9:]*$/.test(value) && value.length <= length;
      }

      const validateEmail = (value, length) => {
          const emailPattern = /^[a-z0-9_]+@([a-z0-9-]+\.)+[a-z0-9]+$/;
          return emailPattern.test(value) && value.length <= length;
      }

      const validateString = (value, regexp) => {
          if(regexp) {
            const stringPattern = regexp || /^[a-z]+$/;
            return stringPattern.test(value);
          }
          return true;
      }

      const getErrorMessage = (item) => {
        switch (item.stype) {
          case 'number':
              return 'Invalid number value.';
          case 'hex':
              return 'Invalid hexadecimal value.';
          case 'fqdn':
              return 'Invalid Fully Qualified Domain Name (FQDN).';
          case 'ipv4':
              return 'Invalid IPv4 address.';
          case 'ipv4mask':
              return 'Invalid IPv4 mask.';
          case 'ipv6':
              return 'Invalid IPv6 address.';
          case 'ipv6prefix':
              return 'Invalid IPv6 prefix.';
          case 'email':
              return 'Invalid email format.';
          case 'string':
              return 'Invalid string format.';
          default:
              return 'Invalid value.';
        }
      }

      const getMaxlength = (stype) => {
            switch (stype) {
                case 'number':
                  if(props.item.digits) {
                    const parts = props.item.digits.split('.');
                    return parseInt(parts[0], 10)+parseInt(parts[1], 10)+1;
                  }
                  return 10;
                case 'hex':
                    return 32;
                case 'fqdn':
                    return 40;
                case 'ipv':
                case 'ipv4':
                case 'ipv4mask':
                    return 20;
                case 'ipv6':
                    return 60;
                case 'ipv6prefix':
                    return 60;
                case 'email':
                    return 100;
                case 'string':
                    return 100;
                default:
                    return 100;
            }
        }

      return {
        updateValue,
        getMaxlength,
        errorMessage,
        error
      }
    }
});
</script>
  